import type { RequestOptions } from './RequestOptions';
import type MailboxRequestOptions from './MailboxRequestOptions';
import isExplicitLogonRequest from './isExplicitLogonRequest';
import { isBootFeatureEnabled } from 'owa-metatags';

export default function isAuthRetriableForRequest(
    requestOptions: RequestOptions | MailboxRequestOptions | undefined
): boolean {
    if (
        requestOptions?.mailboxInfo?.isAnonymous &&
        isBootFeatureEnabled('auth-disableAnonymousTokenForHeader')
    ) {
        // don't retry auth for anonymous requests
        return false;
    }

    if (isExplicitLogonRequest(requestOptions)) {
        // Do not retry auth for explicit logon if the option is set in the request options
        return requestOptions?.retryAuthForExplicitLogon !== false;
    }

    return true;
}
